/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MedicalServiceSystemItemDto
 */
export interface MedicalServiceSystemItemDto {
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceSystemItemDto
     */
    'grossPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceSystemItemDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MedicalServiceSystemItemDto
     */
    'medicalService'?: MedicalServiceSystemItemDtoMedicalServiceEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MedicalServiceSystemItemDtoMedicalServiceEnum {
    Teleconference = 'SOS_TELECONFERENCE',
    Chat = 'SOS_CHAT'
}


